import React from "react";
import Svg, { Path } from "react-native-svg";

const WhatsApp = (props) => (
  <Svg width={24} height={24} fill="none" {...props}>
    <Path
      d="M12.003 0h-.006C5.38 0 0 5.382 0 12c0 2.625.846 5.058 2.284 7.034L.79 23.49l4.613-1.474A11.896 11.896 0 0012.003 24C18.619 24 24 18.616 24 12c0-6.617-5.38-12-11.997-12z"
      fill="#55CD1D"
    />
    <Path
      d="M18.966 16.978c-.289.817-1.433 1.494-2.346 1.692-.625.133-1.44.24-4.187-.902-3.513-1.46-5.775-5.04-5.951-5.272-.169-.233-1.42-1.896-1.42-3.617 0-1.72.872-2.558 1.223-2.918.288-.295.765-.43 1.222-.43.148 0 .28.008.4.014.352.015.528.036.76.592.288.697.99 2.417 1.074 2.594.085.177.17.417.05.649-.112.24-.21.346-.386.55-.177.204-.344.36-.52.578-.162.19-.344.395-.14.747.202.344.905 1.494 1.939 2.417 1.334 1.191 2.416 1.572 2.803 1.734.288.12.632.091.842-.133.268-.29.598-.77.934-1.241.24-.339.541-.38.858-.261.323.112 2.03.96 2.382 1.134.35.177.582.261.667.41.084.148.084.845-.204 1.663z"
      fill="#fff"
    />
  </Svg>
);

export default WhatsApp;
